import React from 'react';

import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Listing, ListingHeader } from 'common-ui/containers';
import { contactBookApi, useAppSelector } from 'core/lib';
import { selectFilteredListing } from 'core/lib/modules/contactBook/store';
import { ListingHeaderActions } from 'modules/contactBook/components';
import { Routes } from 'routes/routes';
import LoaderWrapper from 'utils/loader-wrapper';

import ContactBookListing from '../listing';

const ListingContainer = () => {
  const { t } = useTranslation();
  const { data, isFetching } = contactBookApi.useGetContactBookListingQuery();

  const listingData = useAppSelector((state) => selectFilteredListing(state, data));

  return (
    <Switch>
      <LoaderWrapper loading={isFetching} message={t('loaders:contactBook.loadingListing')}>
        <ListingHeader
          count={listingData?.length ?? 0}
          title={t('global:moduleNames.contactbook')}
          extra={[<ListingHeaderActions key="listingActions" />]}
        />
        <Listing>
          <Switch>
            <Route
              path={Routes.CONTACT_BOOK_LISTING.path}
              exact
              render={() => <ContactBookListing listingData={listingData} />}
            />
            <Redirect to={Routes.DEFAULT.path} />
          </Switch>
        </Listing>
      </LoaderWrapper>
    </Switch>
  );
};

export default ListingContainer;
